module.exports = __webpack_public_path__ + "static/img/home_click_nianhuo@2x.cbf51dad.png";